import { Image } from '../../AbstractElements';
import { dynamicImage } from "../../Services"

export const dummytabledata = [
    {
        id: 1,
        name: <div className='d-flex'>
            <Image attrImage={{ className: 'rounded-circle py-2 img-50 me-3', src: dynamicImage("user/1.jpg"), alt: 'Generic placeholder image' }} />

        </div>,
        date: 'Narmada Parikrama Yatra : A spiritual journey beckons',
        invoice: '#PX0101',
        designation: 'System Architect',
        credit: <span className="f-w-700 font-success"><i className="icofont icofont-arrow-up"></i> 4.3%</span>,
        company: 'Hewlett packard',
        priority: <span className='badge badge-light-primary'>High</span>,
        budget: '$3142.00',
        Language: 'text',
        Country: 'text',
        Designation: 'text',
        Username: 'text',

    }];

export const tableColumns = [
    {
        name: 'Sr. No.',
        selector: row => row.journey_id,
        sortable: true,
        center: true,
        width: '6.25rem',
    },
    {
        name: 'Thumbnail',
        selector: row => row.thumbnail,
        sortable: true,
        center: true,
        width: '8.125rem',
    },
    {
        name: 'Trip Name',
        selector: row => row.trip_name,
        sortable: true,
        center: true,
        width: '9.375rem',
    },
    {
        name: 'Email',
        selector: row => row.email,
        sortable: true,
        center: true,
        width: '12.5rem',
    },
    {
        name: 'Contact Name',
        selector: row => row.contact_name,
        sortable: true,
        center: true,
        width: '9.375rem',
    },
    {
        name: 'Contact Number',
        selector: row => row.contact_number,
        sortable: true,
        center: true,
        width: '9.375rem',
    },
    {
        name: 'Location',
        selector: row => row.location,
        sortable: true,
        center: true,
        width: '9.375rem',
    },
    {
        name: 'Length',
        selector: row => row.trip_length,
        sortable: true,
        center: true,
        width: '6.25rem',
    },
    {
        name: 'Route type',
        selector: row => row.route_type,
        sortable: true,
        center: true,
        width: '7.1875rem',
    },
    {
        name: 'Path',
        selector: row => row.trip_path,
        sortable: true,
        center: true,
        width: '12.5rem',
    },
    {
        name: 'Description',
        selector: row => row.description,
        sortable: true,
        center: true,
        width: '18.75rem',
    },
    {
        name: 'Status',
        selector: row => row.status,
        sortable: true,
        center: true,
        width: '6.25rem',
    },
    {
        name: 'Created By',
        selector: row => row.created_by,
        sortable: true,
        center: true,
        width: '9.375rem',
    },
    {
        name: 'Created On',
        selector: row => new Date(row.created_on).toLocaleString(), // formatting date
        sortable: true,
        center: true,
        width: '12.5rem',
    },
    {
        name: 'Modified By',
        selector: row => row.modified_by,
        sortable: true,
        center: true,
        width: '9.375rem',
    },
    {
        name: 'Modified On',
        selector: row => new Date(row.modified_on).toLocaleString(), // formatting date
        sortable: true,
        center: true,
        width: '12.5rem',
    },
    {
        name: 'Action',
        selector: row => row.action,
        sortable: true,
        center: true,
        width: '9.375rem',
    },
];

